var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWhite = function SvgWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1921,
    height: 1080,
    viewBox: "0 0 1921 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_136_30)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    transform: "translate(0.273438)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.273438,
    y: 0.339844,
    width: 1920.17,
    height: 1080.1,
    fill: "url(#paint0_linear_136_30)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_136_30)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1547.66,
    cy: 232.304,
    rx: 412.681,
    ry: 867.661,
    transform: "rotate(52.5588 1547.66 232.304)",
    fill: "#AB927A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_136_30)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 960.359,
    cy: 880.603,
    rx: 412.681,
    ry: 867.661,
    transform: "rotate(52.5588 960.359 880.603)",
    fill: "#E8D7C0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_136_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1593.05 500.772C1659.62 460.427 1701.48 359.564 1714.09 314.176V626.85C1714.09 674.76 1593.05 757.972 1593.05 768.058C1593.05 776.127 1451.84 801.679 1381.24 813.446L1398.89 677.282C1435.87 635.256 1526.48 541.117 1593.05 500.772Z",
    fill: "#DECBB6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_136_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1479.58 102.365C1395.53 122.537 1225.91 174.482 1219.86 220.878C1213.81 267.275 1390.48 161.201 1479.58 102.365Z",
    fill: "#DECBB6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_136_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M793.714 324.263C858.267 306.107 1069.41 210.792 1166.91 165.404C1166.91 188.939 1147.24 243.068 1068.56 271.31C970.224 306.612 841.624 493.208 750.847 520.945C660.071 548.682 536.514 576.419 407.914 553.725C305.035 535.57 413.798 467.151 481.039 435.212C558.367 405.793 729.161 342.418 793.714 324.263Z",
    fill: "#DECBB6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_136_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1640.37 65.7137C1746.34 -15.9332 1954.65 -4.59354 2045.55 11.2822C2045.55 19.2202 2041.66 41.2197 2026.08 65.7137C2006.6 96.3314 1839.07 177.978 1757.26 198.39C1691.81 214.72 1553.37 289.109 1492.33 324.263C1449.48 320.861 1377.79 304.531 1433.89 266.429C1504.02 218.802 1507.91 167.772 1640.37 65.7137Z",
    fill: "#DECBB6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_136_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M997.962 450.341C1049.23 414.198 1167.91 328.297 1232.47 273.831C1232.47 304.931 1217.34 391.336 1156.82 488.164C1081.17 609.2 897.098 614.243 894.576 626.85C892.055 639.458 705.46 599.113 793.715 571.376C864.319 549.186 959.298 481.44 997.962 450.341Z",
    fill: "#DECBB6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_136_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1093.78 629.372C1178.51 542.63 1349.3 458.746 1424.11 427.647L1381.24 513.38C1336.69 541.958 1256.17 601.13 1290.46 609.2C1324.76 617.269 1393.85 548.682 1424.11 513.38C1424.11 536.074 1409.99 591.044 1353.5 629.372C1282.9 677.282 1290.46 732.756 1272.81 805.882C1255.16 879.007 1161.86 899.18 1093.78 969.783C1025.7 1040.39 914.75 957.176 844.146 899.18C773.542 841.184 987.875 737.799 1093.78 629.372Z",
    fill: "#DECBB6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_136_30)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1068.14,
    cy: 781.903,
    rx: 93.0467,
    ry: 675.193,
    transform: "rotate(52.5588 1068.14 781.903)",
    fill: "#EFE1D4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_136_30",
    x: 314.297,
    y: -888.755,
    width: 2466.73,
    height: 2242.12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_136_30"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_136_30",
    x: -273.008,
    y: -240.456,
    width: 2466.73,
    height: 2242.12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_136_30"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_136_30",
    x: 1281.24,
    y: 214.176,
    width: 532.848,
    height: 699.27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_136_30"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_136_30",
    x: 1119.71,
    y: 2.36499,
    width: 459.871,
    height: 329.938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_136_30"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_136_30",
    x: 265.621,
    y: 65.4041,
    width: 1001.29,
    height: 596.682,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_136_30"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_136_30",
    x: 1313.29,
    y: -100,
    width: 832.258,
    height: 524.263,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_136_30"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_136_30",
    x: 670.027,
    y: 173.831,
    width: 662.438,
    height: 555.396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_136_30"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_136_30",
    x: 730.16,
    y: 327.647,
    width: 793.945,
    height: 769.213,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_136_30"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_136_30",
    x: 29.0352,
    y: -135.246,
    width: 2078.21,
    height: 1834.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_136_30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_136_30",
    x1: 728.907,
    y1: 0.33986,
    x2: 1191.81,
    y2: 1080.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A18B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451923,
    stopColor: "#DFCDB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D836E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_136_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white",
    transform: "translate(0.273438)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "white.5009ef0d7067fccaf8cb81eefabf0541.svg";